import _ from 'lodash';
import React, { useEffect, useRef, useState  } from 'react';
import { Button, Container, Label, Modal, Search, Segment, Grid, Header, Dropdown, Dimmer, Loader, Message, Icon, Tab } from 'semantic-ui-react'
// import './ImpersonateUsers.less';

import { searchSellersData, getLoginLink as _getLoginLink } from '../../services/Manager'

const TIMEOUT = 500;
var searchTimout = undefined;
const ImpersonateSeller = () => {
    
    const [selectedUser, setSelectedUser] = useState({});
    const [searchPhrase, setSearchPhrase] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [users, setUsers] = useState([]);
    const [loginLink, setLoginLink] = useState('');

    useEffect(() => {
        if(searchTimout){
            clearTimeout(searchTimout);
        }
        searchTimout = setTimeout(searchUser, TIMEOUT);
        
    }, [searchPhrase])

    const onSearchChange = (e, data) => {
        
        setSearchPhrase(data.value);
        setSelectedValue(data.value);
    }

    const searchUser = async () => {
        if(!_.isEmpty(searchPhrase) && searchPhrase.length >= 3){
            const usersResponse = await searchSellersData(searchPhrase);
        
            if(usersResponse.resStatus == 200){
                setUsers(usersResponse.data);
            }
        }
                
    }

    const onResultSelect = (e, data) => {
        setSelectedValue(data.result.name);
        setSelectedUser(data.result);
        setLoginLink('');
        
    }

    const resultRenderer = ({firstName, email, name}) => {
        return [<div key={`content`} className='content'>
            {name} &nbsp;
            {<Label color="green">Seller</Label>}
        </div>,
        <div className='description'>{email}</div>]
    }


    const onLoginAsSeller = async () => {
        const usersResponse = await _getLoginLink(selectedUser.userID);
        if(usersResponse.resStatus == 200){
            const link = usersResponse.data.link;
            if (link){
                window.open(link);
            }
        }        
    }

    const getLoginLink = async () => {
        const usersResponse = await _getLoginLink(selectedUser.userID);
        if(usersResponse.resStatus == 200){
            setLoginLink(usersResponse.data.link);
        }
        else{
            setLoginLink('');
        }
        
    }
    return <>
    <Container className="user-container" fluid>
    <Segment className="filter-segment">
        <Grid>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Header>Search Seller</Header>
                    <Search
                        fluid
                        minCharacters={3}
                        onSearchChange={onSearchChange}
                        results={users}
                        resultRenderer={resultRenderer}
                        onResultSelect={onResultSelect}
                        value={selectedValue}
                        className="seller-search search-box"
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </Segment>

        {!_.isEmpty(selectedUser) &&
            <Segment className='selected-user-segment'>
                <div className="name-bar">
                    <div className="user-name">
                        {`${selectedUser.name}`} &nbsp;&nbsp;
                        {<Label color="green">Seller</Label>}
                    </div>

                </div>
                <div>
                    <div className="user-email">{selectedUser.email}</div>
                </div>
                <br />
                <div>
                    {
                        !_.isEmpty(selectedUser) &&
                        <>
                            <Button onClick={onLoginAsSeller}>Login As {selectedUser.name}</Button>
                            <Button onClick={getLoginLink}>Get Login Link</Button>
                            <a href={`${loginLink}`} target="_blank">{loginLink}</a>
                        </>
                    }
                </div>

            </Segment>
        }

    </Container>
    </>

}
export default ImpersonateSeller;